import LegalPageLayout from "../components/layout/LegalPageLayout";
import cookieEN from "../content/legal/cookie-en";
import cookieGR from "../content/legal/cookie-gr";

const CookiePolicy = () => {
  return (
    <LegalPageLayout
      contentEN={cookieEN}
      contentGR={cookieGR}
      titleKey="meta.cookies.title"
      descriptionKey="meta.cookies.description"
      path="/cookie-policy"
    />
  );
};

export default CookiePolicy;
